export const FMCSA = "FMCSA";
export const FMCSA_BUSY = "FMCSA_BUSY";
export const FMCSA_COUNT = "FMCSA_COUNT";
export const FMCSAHISTORY = "FMCSAHISTORY";
export const FMCSAHISTORY_COUNT = "FMCSAHISTORY_COUNT";

